"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSavePropertyRemoteState = void 0;
exports.defaultSavePropertyRemoteState = {
    isSavePropertyIdsRemoteChanged: true,
    savePropertyIdsRemote: [],
};
